import {HttpContextToken} from '@angular/common/http';

/** Returns true only when the owning screen handled this error. */
export type LocalApiErrorHandler = (error: unknown) => boolean;
export const LOCAL_API_ERROR_HANDLER = new HttpContextToken<LocalApiErrorHandler | null>(() => null);
